<p-drawer [(visible)]="filterSidebar" #op position="right">
  <ng-template pTemplate>
    <div class="p-col-12">

      <div class="p-field p-grid">
        <div class="p-col-12">

          <input type="text" [style]="{ width: '100%' }" pInputText [(ngModel)]="nameFilter"
            placeholder="Category name" />
        </div>
      </div>






      <div class="p-field p-grid">
        <div class="p-col-6">
          <button pButton type="reset" class="p-button p-button-secondary btn-block" label="annulla"
            (click)="reset()">
          </button>
        </div>

        <div class="p-col-6">
          <button pButton type="submit" class="p-button p-button-primary btn-block" label="cerca"
            (click)="load()">
          </button>
        </div>

      </div>

    </div>

  </ng-template>
</p-drawer>



<div class="top-main-wrapper">


  <div class="dash-header">
    <div class="dash-title">

      <div class="p-field p-grid">
        <div class="p-col-6 p-md-6">
          <h3>Categories</h3>
        </div>
        <div class="p-col-6 p-md-6">



          <button pButton pRipple icon="pi pi-plus" [routerLink]="['/admin/settings/categories/create']"
          label=" aggiungi" class="p-button p-button-primary -mr-2  pull-right"></button>
          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" labe l="Esporta" (click)="exportPdf()" class="p-button-options p-mr-2 pull-right"  tooltipPosition="bottom"></button> -->


          <button type="text" pButton label="Filter" icon="pi pi-filter"
          class="p-button p-button-options p-mr-2 pull-right" (click)="filterSidebar = true"></button>

        </div>
      </div>

    </div>
  </div>
</div>



<div class="main-inner">





  <div class="p-fluid">
    <div class="p-field p-grid">
      <div class="p-col-12 p-md-12">

        @if (nameFilter) {
          <div class="filter-options">
            <div class="p-field p-grid">
              <div class="p-col-12 p-md-8">
                <div class="item-size pull-left">
                  @if (nameFilter) {
                    <span class="filter-tag">Nome: {{nameFilter}} <span class="close"><i
                    class="pi pi-times" (click)="reset()"></i></span> </span>
                  }
                  @if (descriptionFilter) {
                    <span class="filter-tag">Cognome: {{descriptionFilter}} <span
                      class="close"><i class="pi pi-times" (click)="reset()"></i></span> </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          @for ( category of categories  | paginate: { itemsPerPage: pageSize, currentPage: page, totalItems: count }; track  category; let i = $index) {
            <div
              >
            </div>
          }

          <p-table #dt [columns]="cols" [value]="categories"
            [paginator]="false" [rows]="10">

            <ng-template pTemplate="header" let-columns>
              <tr>

                @for (col of cols; track col) {
                  <th>
                    {{col.header}}
                  </th>
                }
                <th width="200"></th>
              </tr>

            </ng-template>


            <ng-template pTemplate="body" let-rowData let-columns="columns">
              @if (rowData) {
                <tr>
                  <td width="100">
                    @if (rowData.featured == 1) {
                      <p-tag severity="success">Si</p-tag>
                    }
                    @if (rowData.featured == 0) {
                      <p-tag severity="danger">No</p-tag>
                    }
                  </td>
                  <td>
                    <div>{{ rowData.category_name }}</div>
                  </td>
                  <td>
                    <div>{{ rowData.seo_url }}</div>
                  </td>
                  <td width="100">
                    @if (rowData.is_active == 1) {
                      <p-tag severity="success">Si</p-tag>
                    }
                    @if (rowData.is_active == 0) {
                      <p-tag severity="danger">No</p-tag>
                    }
                  </td>
                  <td class="action">
                    <button pButton pRipple icon="pi pi-trash"
                      class="p-button p-button-danger pull-right p-mr-2"
                    (click)="onDelete(rowData.id)"></button>
                    <button pButton pRipple icon="pi pi-pencil"
                      class="p-button p-button-success pull-right p-mr-2"
                    [routerLink]="['/admin/settings/categories/edit', rowData.id]"></button>
                  </td>
                </tr>
              }


            </ng-template>

          </p-table>
          <div class="p-grid">
            <div class="p-col-12 p-md-4">
              <p class="p-pt-1">
                <span class="count-item pull-left">{{pageSize * page - pageSize +1 }} - {{pageSize * page}}
                di {{count}} risultati</span>
              </p>
            </div>
            <div class="p-col-12 p-md-8">
              <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true"
                (pageChange)="handlePageChange($event)">
              </pagination-controls>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <p-drawer [(visible)]="productDialog" position="right" [style]="{width:'50%'}">
    <ng-template pTemplate="content">
      <div class="p-col-12 p-md-12">

        <h1>{{pages.page_title}}</h1>

        <p [innerHTML]="pages.description_1"></p>

        <div class="clearfix"></div><br>
        <button pButton pRipple icon="pi pi-pencil" label="Modifica" class="p-button p-button-primary p-mr-2"
        [routerLink]="['/admin/pages/edit', pages.id]"></button>

      </div>
    </ng-template>
  </p-drawer>




  <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>

    <p-footer>
      <button type="button" pButton icon="fa fa-close" class="p-button p-button-danger p-mr-2" label="No"
      (click)="cd.reject()"></button>
      <button type="button" pButton icon="fa fa-check" class="p-button p-button-success p-mr-2" label="Si"
      (click)="cd.accept()"></button>
    </p-footer>

  </p-confirmDialog>

  <p-toast key="myKey1"></p-toast>

  <p-toast key="myKey2">{{error}}</p-toast>